// src/pages/Dashboard.tsx
import React from "react";
import StatsDisplay from "./topbars/StatsDisplay";

const Dashboard: React.FC = () => {
  return (
    <div className="main-content">
      <StatsDisplay />
    </div>
  );
};

export default Dashboard;
